import React from 'react';
import { Leaf, Users, Target, Award } from 'lucide-react';
import membername from 'src/assets/benamor.jpg';
import edibleCupsImg from "src/assets/images/portfolio.jpg";
import magoBarcaImg from "src/assets/images/magobarca.png";

const About = () => {
  const values = [
    {
      icon: <Leaf size={48} />,
      title: "Sustainability First",
      description: "At Magomeal, every choice we make is guided by our mission to replace plastic with edible, zero-waste alternatives prioritizing both sustainability and a cleaner future for our planet."
    },
    {
      icon: <Users size={48} />,
      title: "Community Focused",
      description: "We believe in creating strong bonds with our customers, partners, and communities across the Benelux by sharing sustainable solutions that inspire positive change."
    },
    {
      icon: <Target size={48} />,
      title: "Innovation Driven",
      description: "Innovating edible cups and packaging to change how the world enjoys food without the waste."
    },
    {
      icon: <Award size={48} />,
      title: "Quality Assured",
      description: "Commitment to excellence in every product we deliver to our valued customers."
    }
  ];

  const team = [
    {
      name: "Ben Amor",
      role: "Founder",
      description: "Engineer"
    }
  ];

  return (
    <div className="about-page">
{/* Hero Section */}
<section className="about-hero">
  <div className="container about-hero-container">
    {/* Left Image */}
    <div className="about-hero-image">
      <img src={edibleCupsImg} alt="Edible cups" className="about-hero-photo" />
    </div>

    {/* Right Text */}
    <div className="about-hero-text">
      <h1 className="display-medium">About Magomeal</h1>
      <p className="body-large">
        Plastic pollution is one of the biggest threats to our environment, with single use packaging at the heart of the problem.
        At Magomeal, we tackle this challenge by creating truly sustainable alternatives that replace waste with value.
        Our flagship edible cups from Cupffee are made from natural grains, vegan, GMO free, and fully biodegradable. They are designed to hold hot drinks without leaking and can be eaten after use or return safely to nature without harmful residues addressing both waste and consumer experience at the same time.
      </p>
      <p className="body-large">
        Alongside edible cups, we offer a range of edible cutlery and tableware crafted from balanced natural grain mixes. These products are sturdy enough to use with hot or cold foods, reducing reliance on plastic utensils and supporting a zerowaste lifestyle. Whether it’s dessert spoons, forks, stirrers, or plates, each item is designed to be enjoyed and then either eaten or composted, helping cut waste from everyday dining occasions.
        By harnessing the power of nature and innovative design, we provide solutions that are both functional and environmentally responsible.
      </p>
      <p className="body-large">
        From cafés and catering to everyday use, our edible products invite you to rethink packaging and tableware turning what was once waste into something beneficial for people and the planet.
      </p>
    </div>
  </div>
</section>

      {/* Story Section */}
<section className="story-section">
  <div className="container story-container">
    {/* Left Text */}
    <div className="story-text">
      <h2 className="heading-1">Our Story</h2>
      <p className="body-large">
        Magomeal was born from a bold idea: to create packaging that not only protects food but becomes part of the meal itself. The name “Magomeal” honors Mago, the Carthaginian engineer and founder of agricultural innovation, and Mago Barca, whose vision and leadership inspire us to think boldly and act with purpose.
      </p>
      <p className="body-large">
Inspired by their creativity and drive, we provide edible packaging that is practical, sustainable, and easy to use. Our edible products can be enjoyed by anyone, from cafés and museums to event organizers and food businesses helping make meals more enjoyable while reducing waste and protecting the environment.
      </p>
    </div>

    {/* Right Image */}
    <div className="story-image">
      <img src={magoBarcaImg} alt="Mago Barca" className="story-photo" />
    </div>
  </div>
</section>

      {/* Values Section */}
      <section className="values-section">
        <div className="container">
          <div className="section-header">
            <h2 className="heading-1">Our Core Values</h2>
            <p className="body-large">
              The principles that guide everything we do
            </p>
          </div>
          
          <div className="network-grid">
            {values.map((value, index) => (
              <div key={index} className="network-card hover-lift">
                <div className="value-icon" style={{ color: 'var(--brand-dark)', marginBottom: 'var(--spacing-small)' }}>
                  {value.icon}
                </div>
                <h3 className="network-card-title">{value.title}</h3>
                <p className="network-card-content">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="team-section">
        <div className="container">
          <div className="section-header">
            <h2 className="heading-1">Meet Our Team</h2>
            <p className="body-large">
              Dedicated to bringing sustainable edible products to the Benelux market
            </p>
          </div>
          
          <div className="team-grid">
            {team.map((member, index) => (
              <div key={index} className="team-card network-card">
                <div className="team-avatar">
                  <img 
                    src={membername}
                    alt={member.name}
                    className="team-photo"
                  />
                </div>
                <h3 className="heading-3">{member.name}</h3>
                <p className="body-medium team-role">{member.role}</p>
                <p className="body-small">{member.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="mission-section">
        <div className="container">
          <div className="mission-content">
            <h2 className="heading-1">Our Mission</h2>
            <p className="body-large">
              At Magomeal, our mission is to change food packaging with smart, edible, and eco-friendly cups. We want to cut waste, give great quality, and make packaging that is good for people and the planet.
            </p>
            <div className="mission-stats">
              <div className="mission-stat">
                <h3 className="display-small">0</h3>
                <p className="body-medium">Waste Goal</p>
              </div>
              <div className="mission-stat">
                <h3 className="display-small">100%</h3>
                <p className="body-medium">100% Edible</p>
              </div>
              <div className="mission-stat">
                <h3 className="display-small">∞</h3>
                <p className="body-medium">Positive Impact</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;